import React from "react";
import { cn } from "@/lib/utils";

const LoadingSpinner = ({ size = "md", className }) => {
  const sizeClasses = {
    sm: "h-2 w-2",
    md: "h-3 w-3",
    lg: "h-4 w-4",
    xl: "h-5 w-5",
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes dotFlashing {
            0% { opacity: 0.2; }
            20% { opacity: 1; }
            100% { opacity: 0.2; }
          }
        `
      }} />
      <div className={cn("flex items-center justify-center space-x-1", className)}>
        <span
          className={cn("rounded-full bg-red-500 opacity-30", sizeClasses[size])}
          style={{ animation: "dotFlashing 1.4s infinite linear" }}
        />
        <span
          className={cn("rounded-full bg-red-500 opacity-30", sizeClasses[size])}
          style={{ animation: "dotFlashing 1.4s infinite linear 0.2s" }}
        />
        <span
          className={cn("rounded-full bg-red-500 opacity-30", sizeClasses[size])}
          style={{ animation: "dotFlashing 1.4s infinite linear 0.4s" }}
        />
      </div>
    </>
  );
};

export default LoadingSpinner;